import React, { createContext, useState, ReactNode } from 'react';
import { PLATAFORMAS, PlataformaId } from './config/api';

interface AppContextProps {
  data: any;
  setData: (data: any) => void;
  activeSeccionId: string | null;
  setActiveSeccionId: (id: string | null) => void;
  activeView: 'seccion' | 'rapidos' | 'populares';
  setActiveView: (view: 'seccion' | 'rapidos' | 'populares') => void;
  plataforma: PlataformaId;
  setPlataforma: (plataforma: PlataformaId) => void;
  isMobileAsideOpen: boolean;
  setMobileAsideOpen: (open: boolean) => void;
}

export const AppContext = createContext<AppContextProps | undefined>(undefined);

interface AppProviderProps {
  children?: ReactNode;
}

const getStoredPlataforma = (): PlataformaId => {
  const stored = localStorage.getItem('plataforma');
  return stored === '2' ? PLATAFORMAS.MOVIL : PLATAFORMAS.WEB;
};

export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
  const [plataforma, setPlataformaState] = useState<PlataformaId>(getStoredPlataforma);
  const [activeSeccionId, setActiveSeccionId] = useState<string | null>(null);
  const [activeView, setActiveView] = useState<'seccion' | 'rapidos' | 'populares'>('seccion');
  const [isMobileAsideOpen, setMobileAsideOpen] = useState(false);
  const [data, setData] = useState<any>({
    vinculos: [],
    perfil: "",
    secciones: [],
    isSoporte: false,
    plataforma: getStoredPlataforma(),
  });

  const setPlataforma = (value: PlataformaId) => {
    localStorage.setItem('plataforma', String(value));
    setPlataformaState(value);
    setData((prev: any) => ({ ...prev, plataforma: value }));
  };

  return (
    <AppContext.Provider value={{ data, setData, plataforma, setPlataforma, activeSeccionId, setActiveSeccionId, activeView, setActiveView, isMobileAsideOpen, setMobileAsideOpen }}>
      {children}
    </AppContext.Provider>
  );
};
